import React, { useEffect, useState } from 'react';
import { useAuth } from '../AuthContext';

const ProfilesPage = () => {
  const [profiles, setProfiles] = useState([]);
  const [filterText, setFilterText] = useState('');
  const [loading, setLoading] = useState(true);
  const { API_BASE_URL } = useAuth();

  const layerOrder = ['device_type', 'os', 'service', 'app_platform', 'application'];
  const layerLabels = {
    'device_type': 'Device Type',
    'os': 'Operating System',
    'service': 'Service',
    'app_platform': 'Application Platform',
    'application': 'Application'
  };

  useEffect(() => {
    const fetchProfiles = async () => {
      const token = localStorage.getItem('token');
      try {
        const response = await fetch(`${API_BASE_URL}profiles`, {
          headers: { Authorization: token },
        });
        const data = await response.json();
        if (Array.isArray(data)) {
          setProfiles(data);
        }
      } catch (err) {
        console.error('Error fetching profiles:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchProfiles();
  }, [API_BASE_URL]);

  const groupProfilesByLayer = () => {
    const grouped = {};
    const filtered = profiles.filter(p => 
      p.name.toLowerCase().includes(filterText.toLowerCase()) ||
      (p.description && p.description.toLowerCase().includes(filterText.toLowerCase()))
    );

    filtered.forEach((profile) => {
      if (!grouped[profile.layer]) {
        grouped[profile.layer] = [];
      }
      grouped[profile.layer].push(profile);
    });
    
    // Sort profiles within each layer by name
    Object.keys(grouped).forEach(layer => {
        grouped[layer].sort((a, b) => a.name.localeCompare(b.name));
    });
    
    return grouped;
  };

  if (loading) {
    return <div className="container mt-4"><p>Loading profiles...</p></div>;
  }

  const groupedProfiles = groupProfilesByLayer();

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2>Profiles</h2>
        <div className="input-group" style={{ maxWidth: '300px' }}>
          <span className="input-group-text">Filter</span>
          <input
            type="text"
            className="form-control"
            placeholder="Search profiles..."
            value={filterText}
            onChange={(e) => setFilterText(e.target.value)}
          />
        </div>
      </div>

      {layerOrder.map((layer) => (
        groupedProfiles[layer] && (
          <div key={layer} className="mb-4 p-3 border rounded bg-white shadow-sm">
            <h4 className="border-bottom pb-2 mb-3">{layerLabels[layer]}</h4>
            <div className="d-flex flex-wrap gap-2">
              {groupedProfiles[layer].map((profile, idx) => (
                <div
                  key={idx}
                  className="px-3 py-2 border rounded d-flex align-items-center"
                  style={{ 
                    cursor: 'help', 
                    minWidth: 'fit-content',
                    backgroundColor: profile.is_new ? '#007bff' : '#e3f2fd',
                    color: profile.is_new ? 'white' : '#0056b3',
                    fontSize: '0.75rem',
                    border: profile.is_new ? 'none' : '1px solid #007bff33'
                  }}
                  title={profile.description || 'No description available'}
                >
                  <span style={{ fontWeight: 500 }}>{profile.name}</span>
                </div>
              ))}
            </div>
          </div>
        )
      ))}
      
      {profiles.length === 0 && (
        <div className="alert alert-info">
          No profiles found. Please synchronize them from the management server.
        </div>
      )}
    </div>
  );
};

export default ProfilesPage;
